import bylineFallback from '@/allas/public/image/byline-fallback.png';
import { SaveArticleButton } from '@/components/SaveArticleButton';
import { useStableProps } from '@/hooks/useStable';
import { StandaloneArticleHeader } from 'base/components/ArticleHeader';
import { useMemo } from 'react';

export const AllasStandaloneArticleHeader: typeof StandaloneArticleHeader = ({ bylines, ...props }) => {
  const bylinesWithPlaceholder = useMemo(
    () =>
      bylines?.map((byline) => ({
        ...byline,
        image: byline.image || bylineFallback,
      })),
    [bylines],
  );

  const stableProps = useStableProps({ options: { variant: 'first' } }, props);

  return (
    <>
      <StandaloneArticleHeader {...stableProps} bylines={bylinesWithPlaceholder} />
      <SaveArticleButton />
    </>
  );
};
